import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

import { ApiResponse } from '../../models/customer-group.model';

/** GET /customers/v1/customers — item in data.content */
export interface CustomerV1ListItem {
  id: number;
  customerId?: number;
  customerName: string;
  accountNumber?: string;
  status?: string;
}

/** GET /customers/v1/customers — full response envelope */
export interface CustomersV1ListResponse {
  status?: number;
  message?: string;
  success?: boolean;
  data?: {
    content?: CustomerV1ListItem[];
    totalElements?: number;
    totalPages?: number;
  };
}

/** POST /customers/v1/customer request body. */

export type CustomerStatus = 'ACTIVE' | 'INACTIVE';



export interface CreateCustomerPayload {

  customerName: string;

  accountNumber: string;

  contactEmail: string;

  contactFirstName: string;

  contactLastName: string;

  phoneNumber: string;

  city?: string;

  state?: string;

  zip?: string;

  country?: string;

  address?: string;

  status: CustomerStatus;

  customerTypeId: number;

  cloudProvider: string;

  wiliotEnabled: boolean;

  /** Optional. Supported tokens: %GWID%, %AssetID%, %Group%. Blank keeps default naming. */
  wiliotGatewayNameFormat?: string | null;

  parentResellerId?: number;

}



/** PUT /customers/v1/customer/{id} — same body shape as create. */

export interface UpdateCustomerPayload extends CreateCustomerPayload {

  id: number | string;

}



/** GET /customers/v1/customer-types item. */

export interface CustomerTypeOption {

  typeId: number;

  typeCode: string;

  label: string;

  isReseller: boolean;

  canHaveChildren: boolean;

  description: string | null;

  isActive: boolean;

}

/** BE customer type IDs: 1 = Reseller, 2 = Customer */
export const CUSTOMER_TYPE_ID_RESELLER = 1;
export const CUSTOMER_TYPE_ID_CUSTOMER = 2;

/** @deprecated Use CreateCustomerPayload */

export type CustomerPayload = CreateCustomerPayload;



@Injectable({

  providedIn: 'root',

})

export class CustomerService {

  private apiUrl = environment.apiUrl.trim();



  constructor(private http: HttpClient) {}



  getAllCustomer(payload: any): Observable<any> {

    const url = this.apiUrl + '/customers/v1/customer/search';

    return this.http.post(url, payload);

  }



  /**

   * GET /customers/v1/customer-types

   */

  getCustomerTypes(): Observable<CustomerTypeOption[]> {

    return this.http

      .get<{ data?: CustomerTypeOption[] } | CustomerTypeOption[]>(

        `${this.apiUrl}/customers/v1/customer-types`

      )

      .pipe(

        map((response) => {

          const list = Array.isArray(response)

            ? response

            : (response?.data ?? []);

          return list.filter((t) => t.isActive !== false);

        })

      );

  }



  updateCustomerOnly(

    payload: UpdateCustomerPayload,

    customerId: number | string

  ): Observable<any> {

    const { id: _id, ...body } = payload;

    return this.http.put(

      `${this.apiUrl}/customers/v1/customer/${customerId}`,

      body

    );

  }



  createCustomer(payload: CreateCustomerPayload): Observable<any> {

    return this.http.post(`${this.apiUrl}/customers/v1/customer`, payload);

  }



  getCustomerById(customerId: number | string): Observable<any> {

    return this.http.get(`${this.apiUrl}/customers/v1/customer/${customerId}`);

  }



  /** DELETE /customers/v1/customer/{id} */

  deleteCustomer(customerId: number | string): Observable<void> {

    return this.http.delete<void>(

      `${this.apiUrl}/customers/v1/customer/${customerId}`

    );

  }



  getCustomersAndGroups(page: number, size: number): Observable<ApiResponse> {

    const url =

      this.apiUrl +

      `/customers/v1/customers-with-groups?page=${page}&size=${size}`;

    return this.http.get<ApiResponse>(url);

  }



  /**

   * GET /customers/v1/customers — paginated customer list (device service).

   */

  getCustomersV1(page: number, size: number): Observable<CustomerV1ListItem[]> {

    return this.http

      .get<CustomersV1ListResponse>(

        `${this.apiUrl}/customers/v1/customers?page=${page}&size=${size}`

      )

      .pipe(map((response) => response?.data?.content ?? []));

  }

  /**
   * GET /customers/v1/account-number/{accountNumber}/exists
   * Returns true when the account number is already assigned to a customer.
   */
  checkAccountNumberExists(accountNumber: string): Observable<boolean> {
    const encoded = encodeURIComponent(accountNumber.trim());
    return this.http
      .get<{ data?: boolean } | boolean>(
        `${this.apiUrl}/customers/v1/account-number/${encoded}/exists`
      )
      .pipe(
        map((response) => {
          if (typeof response === 'boolean') {
            return response;
          }
          return response?.data === true;
        })
      );
  }

  /**
   * GET /customers/v1/resellers — Parent Customer dropdown (Customer type only).
   */
  getResellerCustomers(): Observable<CustomerV1ListItem[]> {
    return this.http
      .get<
        | CustomerV1ListItem[]
        | { data?: CustomerV1ListItem[] | { content?: CustomerV1ListItem[] } }
      >(`${this.apiUrl}/customers/v1/resellers`)
      .pipe(
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          const data = response?.data;
          if (Array.isArray(data)) {
            return data;
          }
          return data?.content ?? [];
        })
      );
  }

}


